import { schema } from "normalizr";
import { ShippingPromotion } from "./shipping-promotion";

export const ShippingPromotions = new schema.Array(ShippingPromotion);
